// import React, { useEffect } from 'react';
// import "./SportOneCategories.scss";
// import "aos/dist/aos.css";
// import AOS from "aos";
// import { useCollection } from '../../../../firebase-files/hooks/useCollection';

// const SportOneCategories = () => {
//   useEffect(() => {
//     AOS.init({
//       duration: 1500,
//       easing: "ease-in-out",
//       once: false,
//     });
//   }, []);
//     const { documents: dbCollectionDocument, error: dbCollectionDocumentError } =
//   useCollection("m_categories");  // name of existing documets collection
// console.log("hello ",dbCollectionDocument && dbCollectionDocument[0].category);

//   return (
//     <section className="sport-one-fitness-section sport-one-reverse"  onClick={() => navigate(`/product-details-two/${product.id}`)}>>
//     {/* Section 1: Two-column layout */}
//     <div className="fitness fitness-two-column">
//       <div className="image-box" data-aos="zoom-in">
//         <img src="/assets/img/sports/sport-one/images/yoga1.jpg" alt="Yoga 1" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="200">
//           One membership for all your fitness needs
//         </div>
//       </div>
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="300">
//         <img src="/assets/img/sports/sport-one/images/yoga2.jpg" alt="Yoga 2" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="400">
//           Fun, trainer-led group classes
//         </div>
//       </div>
//     </div>

//     {/* Section 2: Three-column layout */}
//     <div className="fitness fitness-three-column">
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="500">
//         <img src="/assets/img/sports/sport-one/images/fitness7.jpg" alt="Fitness 1" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="600">
//           Strength & Conditioning
//         </div>
//       </div>
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="700">
//         <img src="/assets/img/sports/sport-one/images/fitness4.jpg" alt="Fitness 2" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="800">
//           Speed & Agility Training
//         </div>
//       </div>
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="900">
//         <img src="/assets/img/sports/sport-one/images/fitness5.jpg" alt="Fitness 3" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="1000">
//           Mobility & Recovery
//         </div>
//       </div>
//     </div>

//     {/* Section 3: Grid of 8 images */}
//     <div className="fitness fitness-grid">
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="1100">
//         <img src="/assets/img/sports/sport-one/images/training1.jpg" alt="Grid 1" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="1200">
//           Game Simulation
//         </div>
//       </div>
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="1300">
//         <img src="/assets/img/sports/sport-one/images/training2.jpg" alt="Grid 2" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="1400">
//           Doubles Coordination
//         </div>
//       </div>
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="1500">
//         <img src="/assets/img/sports/sport-one/images/training4.jpg" alt="Grid 3" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="1600">
//           Net Play Mastery
//         </div>
//       </div>
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="1700">
//         <img src="/assets/img/sports/sport-one/images/training5.jpg" alt="Grid 4" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="1800">
//           Smash Techniques
//         </div>
//       </div>
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="1900">
//         <img src="/assets/img/sports/sport-one/images/training10.jpg" alt="Grid 5" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="2000">
//           Endurance Circuits
//         </div>
//       </div>
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="2100">
//         <img src="/assets/img/sports/sport-one/images/training7.jpg" alt="Grid 6" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="2200">
//           Backhand Focus
//         </div>
//       </div>
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="2300">
//         <img src="/assets/img/sports/sport-one/images/training9.jpg" alt="Grid 7" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="2400">
//           Reaction Training
//         </div>
//       </div>
//       <div className="image-box" data-aos="zoom-in" data-aos-delay="2500">
//         <img src="/assets/img/sports/sport-one/images/training17.jpg" alt="Grid 8" />
//         <div className="overlay-text" data-aos="fade-up" data-aos-delay="2600">
//           Precision Drills
//         </div>
//       </div>
//     </div>
//   </section>

//   );
// };

// export default SportOneCategories;

//2

// import React, { useEffect } from 'react';
// import "./SportOneCategories.scss";
// import "aos/dist/aos.css";
// import AOS from "aos";
// import { useCollection } from '../../../../firebase-files/hooks/useCollection';
// import { useNavigate } from 'react-router-dom';

// const SportOneCategories = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     AOS.init({
//       duration: 1500,
//       easing: "ease-in-out",
//       once: false,
//     });
//   }, []);

//   const { documents: dbCollectionDocument, error: dbCollectionDocumentError } = useCollection("m_categories");

//   const handleCategoryClick = (category) => {
//     navigate(`/products?category=${encodeURIComponent(category)}`);
//   };

//   return (
//     <section className="sport-one-fitness-section sport-one-reverse">
//       <br />

//       <div >
//       <h2>W18 Categories</h2>
//       </div>

//       <div className="fitness fitness-grid">
//         {dbCollectionDocument && dbCollectionDocument.map((item, index) => (
//           <div
//             className="image-box"
//             key={item.id || index}
//             data-aos="zoom-in"
//             data-aos-delay={index * 200}
//             onClick={() => handleCategoryClick(item.category)}
//           >
//             <img src={item.categoryImgUrl} alt={item.category} />
//             <div
//               className="overlay-text"
//               data-aos="fade-up"
//               data-aos-delay={index * 200 + 100}
//             >
//               {item.category}
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default SportOneCategories;

//3

// import React, { useEffect } from 'react';
// import "./SportOneCategories.scss";
// import "aos/dist/aos.css";
// import AOS from "aos";
// import { useCollection } from '../../../../firebase-files/hooks/useCollection';
// import { useNavigate } from 'react-router-dom';

// const SportOneCategories = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     AOS.init({
//       duration: 1500,
//       easing: "ease-in-out",
//       once: false,
//     });
//   }, []);

//   const { documents: dbCollectionDocument } = useCollection("m_categories");

//   const handleCategoryClick = (category) => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//     navigate(`/products?category=${encodeURIComponent(category)}`);
//   };

//   return (
//     <section className="sport-one-fitness-section sport-one-reverse">
//       <div className="category-heading-container">
//         <h2 className="category-heading">W18 Categories</h2>
//       </div>

//       <div className="fitness fitness-grid">
//         {dbCollectionDocument && dbCollectionDocument.map((item, index) => (
//           <div
//             className="image-box"
//             key={item.id || index}
//             data-aos="zoom-in"
//             data-aos-delay={index * 200}
//             onClick={() => handleCategoryClick(item.category)}
//           >
//             <img src={item.categoryImgUrl} alt={item.category} />
//             <div
//               className="overlay-text"
//               data-aos="fade-up"
//               data-aos-delay={index * 200 + 100}
//             >
//               {item.category}
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default SportOneCategories;

//4
// import React, { useEffect } from 'react';
// import "./SportOneCategories.scss";
// import "aos/dist/aos.css";
// import AOS from "aos";
// import { useCollection } from '../../../../firebase-files/hooks/useCollection';
// import { useNavigate } from 'react-router-dom';

// const SportOneCategories = () => {
//   const navigate = useNavigate();
//   const { documents: dbCollectionDocument } = useCollection("m_categories");

//   useEffect(() => {
//     AOS.init({ duration: 1500, once: false });
//   }, []);

//   const handleCategoryClick = (category) => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//     navigate(`/products?category=${encodeURIComponent(category)}`);
//   };

//   return (
//     <section className="sport-one-fitness-section sport-one-reverse">
//       <h2 className="section-title">W18 Categories</h2>
//       <div className="fitness fitness-grid">
//         {dbCollectionDocument &&
//           dbCollectionDocument.map((item, index) => (
//             <div
//               className="image-box"
//               key={item.id || index}
//               data-aos="zoom-in"
//               data-aos-delay={index * 200}
//               onClick={() => handleCategoryClick(item.category)}
//             >
//               <img src={item.categoryImgUrl} alt={item.category} />
//               <div className="overlay-text" data-aos="fade-up" data-aos-delay={index * 200 + 100}>
//                 {item.category}
//               </div>
//             </div>
//           ))}
//       </div>
//     </section>
//   );
// };

// export default SportOneCategories;

//5
// import React, { useEffect } from 'react';
// import "./SportOneCategories.scss";
// import "aos/dist/aos.css";
// import AOS from "aos";
// import { useCollection } from '../../../../firebase-files/hooks/useCollection';
// import { useNavigate } from 'react-router-dom';

// const SportOneCategories = () => {
//   const navigate = useNavigate();
//   const { documents: dbCollectionDocument } = useCollection("m_categories");

//   useEffect(() => {
//     AOS.init({ duration: 1500, once: false });
//   }, []);

//   const handleCategoryClick = (category) => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//     navigate(`/products?category=${encodeURIComponent(category)}`);
//   };

//   const getCategoryRows = () => {
//     if (!dbCollectionDocument) return [];

//     const row1 = dbCollectionDocument.slice(0, 2); // first 2
//     const row2 = dbCollectionDocument.slice(2, 5); // next 3
//     const row3 = dbCollectionDocument.slice(5, 7); // last 2

//     return [row1, row2, row3];
//   };

//   const categoryRows = getCategoryRows();

//   return (
//     <section className="sport-one-fitness-section sport-one-reverse">
//       <h2 className="section-title">W18 Categories</h2>

//       {categoryRows.map((row, rowIndex) => (
//         <div className="fitness-row" key={rowIndex}>
//           {row.map((item, index) => (
//             <div
//               className="image-box"
//               key={item.id || `${rowIndex}-${index}`}
//               data-aos="zoom-in"
//               data-aos-delay={index * 200}
//               onClick={() => handleCategoryClick(item.category)}
//             >
//               <img src={item.categoryImgUrl} alt={item.category} />
//               <div className="overlay-text" data-aos="fade-up" data-aos-delay={index * 200 + 100}>
//                 {item.category}
//               </div>
//             </div>
//           ))}
//         </div>
//       ))}
//     </section>
//   );
// };

// export default SportOneCategories;

import React, { useEffect } from "react";
import "./SportOneCategories.scss";
import "aos/dist/aos.css";
import AOS from "aos";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { useNavigate } from "react-router-dom";

const SportOneCategories = () => {
  const navigate = useNavigate();
  const { documents: dbCollectionDocument } = useCollection("m_categories");

  useEffect(() => {
    AOS.init({ duration: 1500, once: false });
  }, []);

  const handleCategoryClick = (category) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/products?category=${encodeURIComponent(category)}`);
  };

  const getCategoryRows = () => {
    if (!dbCollectionDocument) return [];

    // Filter only active categories
    const activeCategories = dbCollectionDocument.filter(
      (cat) => cat.status === "active"
    );

    const row1 = activeCategories.slice(0, 2);
    const row2 = activeCategories.slice(2, 5);
    const row3 = activeCategories.slice(5, 7);

    return [row1, row2, row3].filter((row) => row.length > 0); // Remove empty rows
  };

  const categoryRows = getCategoryRows();

  return (
    <section className="sport-one-fitness-section sport-one-reverse">
      <h2 className="section-title">Discover Happiness Together</h2>
      <p className="w18-subheading">
        <span>experience sports, fitness & leisure under one roof</span>
      </p>

      {categoryRows.map((row, rowIndex) => (
        <div className="fitness-row" key={rowIndex}>
          {row.map((item, index) => (
            <div
              className="image-box"
              key={item.id || `${rowIndex}-${index}`}
              data-aos="zoom-in"
              data-aos-delay={index * 200}
              onClick={() => handleCategoryClick(item.category)}
            >
              <img src={item.categoryImgUrl} alt={item.category} />
              <div
                className="overlay-text"
                data-aos="fade-up"
                data-aos-delay={index * 200 + 100}
              >
                {item.category}
              </div>
            </div>
          ))}
        </div>
      ))}
    </section>
  );
};

export default SportOneCategories;
